import orderBy from 'lodash/orderBy'
import LeadTagForm from './_lead-tags-form.js'
import template from './lead-tags.pug'
import modalLeadTagsConfig from './provider/modal-leadtags-config.js'

const defaultNoDataImg = require('assets/images/content/empty-state.svg')

export default Vue.extend({
  name: 'LeadTags',
  template: template(),
  components: {
    LeadTagForm,
    'modal-leadtags-config': modalLeadTagsConfig
  },
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      noDataImg: defaultNoDataImg,
      leadTags: [],
      paginatedLeadTags: [],
      leadTagFormData: {},
      leadTagFormErrors: {},
      showForm: false,
      showModal: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      },
      selectorOptions: [2, 4, 8, 10,20]
    }
  },
  computed: {
    campaignId() {
      return this.campaign.id
    },

    defaultOrder() {
      return { currentField: 'name', currentDir: 'asc' }
    },

    formMode() {
      return this.leadTagFormData.id ? 'edit' : 'new'
    },

    lastElementInPage() {
      const max = this.pagination.currentPage * this.pagination.pageSize
      return max > this.pagination.totalElements ? this.pagination.totalElements : max
    },

    firstElementInPage() {
      return 1 + ((this.pagination.currentPage - 1) * this.pagination.pageSize)
    },

    dataText() {
      return {
        totalElements: this.pagination.totalElements,
        startPageElement: this.firstElementInPage,
        finishPageElement: this.lastElementInPage
      }
    }
  },
  async created() {
    await this.loadLeadTags()
    this.ready = true
  },
  methods: {
    async loadLeadTags() {
      if (!API || !API || !API.tags || typeof API.tags.getTagsByCampaign !== 'function') {
        console.error('API.campaigns.tags is not defined or index function is not available')
        return
      }

      try {
        const { data } = await API.tags.getTagsByCampaign(
          this.campaignId,
          { order: { name: 'asc' }, page: { number: 1, size: 1000 } }
        )
        if (data) {
          this.leadTags = data
          this.pagination.totalElements = data.length
          this.pagination.totalPages = Math.ceil(data.length / this.pagination.pageSize)
          this.updatePaginatedLeadTags()
        } else {
          console.error('No data returned from API')
        }
      } catch (error) {
        console.error('Error loading lead tags:', error)
      }
    },
    //Esto se encarga de la paginación de los tags
    updatePaginatedLeadTags() {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize
      const end = start + this.pagination.pageSize
      this.paginatedLeadTags = this.leadTags.slice(start, end)
    },

    changeOrder(field, dir) {
      this.leadTags = orderBy(
        this.leadTags,
        item => item[field].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        dir
      )
      this.updatePaginatedLeadTags()
    },

    changePage(page) {
      this.pagination.currentPage = page
      this.updatePaginatedLeadTags()
    },

    changePageSize(event) {
      const value = parseInt(event.target.value)
      this.pagination.pageSize = value
      this.pagination.totalPages = Math.ceil(this.pagination.totalElements / value)
      this.pagination.currentPage = 1
      this.updatePaginatedLeadTags()
    },

    openNewForm() {
      this.leadTagFormData = {
        campaignId: this.campaignId
      }
      this.showForm = true
    },

    openEditForm(item) {
      this.leadTagFormData = {
        id: item.id,
        name: item.name,
        fieldType: item.fieldType, 
        campaignId: item.campaignId
      }
      console.log(item);
      this.showForm = true
      this.showModal = true // Abrimos el modal
    },

    closeModal() {
      this.leadTagFormData = {}
      this.leadTagFormErrors = {}
      this.showForm = false
      this.showModal = false // Cerramos el modal
    },
    //Acá guardamos los cambios en el archivo principal
    saveLeadTag(data) {

      this.leadTagFormErrors = {}

      if (this.formMode === 'edit') {
        this.updateLeadTag(data)
      } else {
        this.createLeadTag(data)
      }
    },

    updateLeadTag(data) {
      if (API && API.tags && API.tags.updateTag) {
        API.tags.updateTag(data.id, data).then(() => {
          this.$notifications.success(this.t('succesfullyUpdated'))
          this.loadLeadTags()
          this.closeModal()
        }).catch(errors => {
          this.leadTagFormErrors = errors
        })
      } else {
        console.error('API.campaigns.tags.update is not defined')
      }
    },

    t(key, options = {}) {
      return this.$t(`campaigns.show.config.tabs.leadTags.${key}`, options)
    }
  }
})
